export default __webpack_public_path__ + "static/media/E-MONEY.79296b3e.svg";